// extracted by mini-css-extract-plugin
export default {"display_left":"style_display_left__jRsu1","display_right":"style_display_right__2KF2S","table_wrap":"style_table_wrap__GkwJH"};